import {Component, DoCheck, IterableDiffers, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {Permission} from '../../../_models/permission';
import {PermissionService} from '../../../_services/permission.service';
import {BsModalRef} from 'ngx-bootstrap/modal/modal-options.class';
import {Http} from '@angular/http';
import {BsModalService} from 'ngx-bootstrap/modal';
import { checkAndUpdatePureExpressionInline } from '@angular/core/src/view/pure_expression';
import { RoleService } from '../../../_services/role.service';
import { AccountsService } from '../../../_services/accounts.service';
import { Role } from 'app/_models/role';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss'],
  providers: [ PermissionService ]
  
})
export class PermissionComponent implements OnInit, DoCheck {
  dtOptions: DataTables.Settings = {};
  public temp_var: Object = false;

  public permissionId = '';
  nameErrorMsg = '';
  aliasErrorMsg = '';
  descriptionErrorMsg = '';
  emailErrorMsg = '';
  passwordErrorMsg = '';
  passwordConfErrorMsg = '';
  passwordMatchErrorMsg = '';
  adminPasswordErrorMsg = '';

  public roles = [];
  public newRoles = [];

  public isEdit = false;
  public accounts: Array<any>;
  public newAccounts: Array<any>;
  public permissions: Array<any>;
  public isLoading = true;

  // public account: Account;
  public permission: Permission;
  public role: Role;
  public currentPermission: Permission;
  // public currentAccount: Account;
  public adminPassword = '';

  modalRef: BsModalRef;
  modalRef1: BsModalRef;
  public config2 = {
    keyboard: false,
    backdrop: 'static',
    class: 'modal-lg'
  };
  public config1 = {
    keyboard: false,
    backdrop: 'static',
    class: 'modal-sm'
  };
  differ: any;

  constructor(private http: Http,
              private modalService: BsModalService,
              private toastrService: ToastrService,
              private permissionService: PermissionService,
              private roleService : RoleService,
              private accountsService : AccountsService,
              private differs: IterableDiffers) {
    this.differ = differs.find([]).create(null);
  }

  ngDoCheck(): void {
    const change = this.differ.diff(this.permissions);
    if (change !== null) {
      // this.isLoading = false;
    }
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: false,
      language: {
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        infoEmpty: 'Không tìm thấy quyền nào phù hợp',
        infoFiltered: '(trong _MAX_ quyền)',
        lengthMenu: 'Hiển thị _MENU_ quyền',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có quyền nào',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        {'targets': [0, 1, 2, 3, 4, 5, 6], 'searchable': true}
      ]
    };
    this.getTable();
  }

  getTable() {
    this.permissionService.index().subscribe(response => {
      if (response.success) {
        this.permissions = response.data.permissions;
        this.isLoading = false;
      }
    });
  }

  addPermission(template) {
    this.permission = new Permission();
    this.isEdit = false;
    this.adminPassword = '';    
    this.emailErrorMsg = '';
    this.passwordErrorMsg = '';
    this.passwordConfErrorMsg = '';
    this.passwordMatchErrorMsg = '';
    this.adminPasswordErrorMsg = '';
    this.nameErrorMsg = '';
    this.aliasErrorMsg = '';
    this.modalRef = this.modalService.show(template, this.config2);
  }

  editPermission(template, item) {
    this.isEdit = true;
    this.permission = new Permission();
    this.permission.name = item.name;
    this.permission.alias = item.alias;
    this.permission.description = item.description;
    this.currentPermission = new Permission();
    this.currentPermission.name = item.name;
    this.currentPermission.alias = item.alias;
    this.currentPermission.description = item.description;
    this.nameErrorMsg = '';
    this.aliasErrorMsg = '';
    this.modalRef = this.modalService.show(template, this.config2);
  }

  create() {
    if (this.check()) {
      this.permissionService.create(this.permission)
        .subscribe(response => {
            if (response.success) {
              this.isLoading = true;
              this.toastrService.success('Tạo quyền mới!', 'Thông báo');
              this.modalRef.hide();
              this.getTable();
            } else {
              this.toastrService.warning(response.message, 'Thông báo');
            }
          },
          err => {
            this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
            //console.log(err);
          });
    } else {
      this.toastrService.warning('Chưa đủ thông tin hoặc thông tin không tính xác!', 'Cảnh báo');
    }
  }

  update() {
    if (this.check()) {
      //this.permission['adminPassword'] = this.adminPassword;
      if (this.permission.name !== this.currentPermission.name ||
        this.permission.alias !== this.currentPermission.alias ||
        this.permission.description !== this.currentPermission.description) 
      {
        this.permissionService.update(this.permission.alias, this.permission)
          .subscribe(response => {
              if (response.success) {
                this.isLoading = true;
                this.toastrService.success('Cập nhật quyền thành công!', 'Thông báo');
                this.getTable();
                this.modalRef.hide();
              } else {
                this.toastrService.warning(response.message, 'Thông báo');
              }
            },
            err => {
              this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
            });
      }

      if (this.permission.name === this.currentPermission.name && this.permission.alias === this.currentPermission.alias &&
        this.permission.description === this.currentPermission.description )
      {
        this.toastrService.success('Cập nhật thành công !', 'Thông báo');
        this.modalRef.hide();
      }
    } else {
      this.toastrService.warning('Chưa đủ thông tin hoặc thông tin không chính xác!', 'Cảnh báo');
    }
  }

  check() {
    this.checkName();
    this.checkAlias();
    return !this.nameErrorMsg && !this.aliasErrorMsg;
  }

  checkName() {
    this.nameErrorMsg = '';
    if (this.permission.name === '') {
      this.nameErrorMsg = 'Tên quyền không được để trống';
    } else {
      const usernamePattern = '^[a-z0-9-_ ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚÝàáâãèéêìíòóôõùúýĂăĐđĨĩŨũƠơƯưẠ-ỹ]{1,50}$';
      if (this.permission.name.toLowerCase().match(usernamePattern) === null) {
        this.nameErrorMsg = 'Tên quyền không đúng định dạng';
      }
    }
  }

  checkAlias() {
    this.aliasErrorMsg = '';
    if (this.permission.alias === '') {
      this.aliasErrorMsg = 'Alias không được để trống';
    } else {
      const usernamePattern = '^[a-z0-9-_]{1,30}$';
      if (this.permission.alias.toLowerCase().match(usernamePattern) === null) {
        this.aliasErrorMsg = 'Alias không đúng định dạng';
      }
    }
  }

  checkDescription() {
    this.descriptionErrorMsg = '';
    if (this.permission.description === '') {
      this.descriptionErrorMsg = 'Tên mô tả không được rỗng';
    } else {
      const usernamePattern = '^[a-z0-9-_ ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚÝàáâãèéêìíòóôõùúýĂăĐđĨĩŨũƠơƯưẠ-ỹ]{1,100}$';
      if (this.permission.description.toLowerCase().match(usernamePattern) === null) {
        this.descriptionErrorMsg = 'Mô tả không đúng định dạng';
      }
    }
  }

  checkAdminPassword() {
    this.adminPasswordErrorMsg = '';
    if (this.isEdit && (this.adminPassword === undefined || this.adminPassword === '')) {
      this.adminPasswordErrorMsg = 'Bạn phải nhập mật khẩu người quản trị để xác nhận!';
    }
  }

  deletePermission(template, item) {
    this.permission = item;
    this.adminPassword = '';
    this.modalRef1 = this.modalService.show(template, this.config1);
  }

  delete() {
    if (this.adminPassword !== null && this.adminPassword !== '') {
      this.permissionService.delete(this.permission.alias, {adminPassword: this.adminPassword})
        .subscribe(response => {
            if (response.success) {
              this.isLoading = true;
              this.modalRef1.hide();
              
              // Cập nhật lại permission trong roles và trong account
              this.updateRole(this.permission._id);
              this.updateAccount(this.permission._id);
              this.toastrService.success('Xóa quyền thành công!', 'Thông báo');
            } else {
              this.toastrService.warning(response.message, 'Thông báo');
            }
          },
          err => {            
            this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
          });
    } else {
      
      this.toastrService.warning('Không có mật khẩu người quản trị', 'Cảnh báo');
    }
  }


  updateRole(permissionId){
    this.roleService.findRolesByPermission(permissionId)
    .subscribe(response => {
        if (response.success) {
          this.roles = response.data.data.roles;          
          let arr = Array();
          this.roles.forEach(role => {
            if(role.permission.length == 1){
              role.permission = null;
            }
            else{
                role.permission.forEach(permission =>{                    
                    if(permissionId != permission.value){
                        arr.push(permission);
                    }
                });
            }
            //cập nhật lại permission trong role
            role.permission = arr;
            arr = [];

          });
          this.updateRolePermission(this.roles);
          this.isLoading = true;
        } else {
          this.toastrService.warning(response.message, 'Thông báo');
        }
      },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }

   updateAccount(permissionId){
    // tìm tất cả account đang có permission này
    this.accountsService.findAccountsByPermission(permissionId)
    .subscribe(response => {
        if (response.success) {
          this.accounts = response.data.account;   
          let arr = Array();
          this.accounts.forEach(account => {
              account.role.forEach(permission =>{ 
                
                permission.value.forEach(permissionTemp =>{ 
                  if(permissionId != permissionTemp.value){
                      arr.push(permissionTemp);
                  }
                });
                permission.value = arr;
                arr = [];
              });
          });
          this.updateAccountRole("update", this.accounts);
          this.isLoading = true;
        } else {
          this.toastrService.warning(response.message, 'Thông báo');
        }
      },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }

  // CẬP NHẬT ROLE CHO ACCOUNT
   updateAccountRole(action, accounts){
     this.accountsService.updateMany(action, {listAccount: accounts})
    .subscribe(response => {
      if (response.success) { 
        this.isLoading = true;
        this.getTable();
      } else {
        this.toastrService.warning(response.message, 'Thông báo');
      }
    },
    err => {
      this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
    });
  }

  updateRolePermission(roles){
    this.roleService.updateMany(roles)
    .subscribe(response => {
      if (response.success) { 
        this.isLoading = true;
        this.getTable();
      } else {
        this.toastrService.warning(response.message, 'Thông báo');
      }
    },
    err => {
      this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
    });
  }

  closeModal() {
    this.isLoading = false;
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/system/permission/permission.component.ts